import React from 'react';
import { IActivedTab } from '../index';

interface IProps {
  activedtab : IActivedTab;
  setActivedtab: React.Dispatch<React.SetStateAction<IActivedTab>>;
}

export function Navbar( { activedtab,setActivedtab}:IProps) {

  const handleTabClick = (tab: keyof IActivedTab) => {
    setActivedtab({
      sabores: false,
      borda: false,
      extra: false,
      comentario: false,
      [tab]: true,
    });
  };
  
  return (
    <nav>
      <ul>
        <li
          className={activedtab.sabores ? "active" : ""}
          onClick={() => handleTabClick("sabores")}
        >
          Sabores
        </li>
        <li
          className={activedtab.borda ? "active" : ""}
          onClick={() => handleTabClick("borda")}
        >
          Borda
        </li>
        <li
          className={activedtab.extra ? "active" : ""}
          onClick={() => handleTabClick("extra")}
        >
          Extra
        </li>
        <li
          className={activedtab.comentario ? "active" : ""}
          onClick={() => handleTabClick("comentario")}
        >
          Comentário
        </li>
      </ul>
    </nav>
  )
}